
import Input from "../../../common/input/Input";

export default function FieldTitle({ title, onChange }) {
	return (
		<>
			<Input
				onChange={onChange}
				value={title}
				label={"عنوان مقاله"}
				placeholder={"درمان حواس پرتی"}
			/>
		</>
	)
}
